import { render, staticRenderFns } from "./BatchEditGroup.vue?vue&type=template&id=30dde8fb&scoped=true"
import script from "./BatchEditGroup.vue?vue&type=script&lang=ts"
export * from "./BatchEditGroup.vue?vue&type=script&lang=ts"
import style0 from "./BatchEditGroup.vue?vue&type=style&index=0&id=30dde8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dde8fb",
  null
  
)

export default component.exports